import i18n from '../i18n/config';

// USD amounts are shown to US-based applicants regardless of UI language, so
// currency formatting always uses the US grouping/symbol convention for each
// supported language (e.g. "es" -> "es-US") rather than a generic locale
// (e.g. "es") that would use unfamiliar separators like "15.000 US$".
const CURRENCY_LOCALES: Record<string, string> = {
  en: 'en-US',
  es: 'es-US',
};

export const getCurrencyLocale = (language: string): string =>
  CURRENCY_LOCALES[language] ?? CURRENCY_LOCALES.en;

// Currency formatting
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat(getCurrencyLocale(i18n.language), {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

const translateEnum = (group: string, value: string): string => {
  const key = `formatting.${group}.${value}`;
  const translated = i18n.t(key, { ns: 'wizard' });
  return translated === key ? i18n.t('formatting.notSpecified', { ns: 'wizard' }) : translated;
};

// Loan purpose formatting
export const getLoanPurpose = (value: string): string => translateEnum('loanPurpose', value);

// Employment status formatting
export const getEmploymentStatus = (value: string): string => translateEnum('employmentStatus', value);

// Property status formatting
export const getPropertyStatus = (value: string): string => translateEnum('propertyStatus', value);

// Education level formatting
export const getEducationLevel = (value: string): string => translateEnum('educationLevel', value);
